<div>
    <div class="container">
        <div class="col-md-12 lease_table">
            <div>
                <div class="d-flex list justify-content-between align-items-center">

                    <!-- LEFT TITLE -->
                    <div class="migration_detials">Student Feedback</div>

                    <!-- RIGHT SIDE (Tabs + Filter) -->
                    <div class="d-flex align-items-center">

                        <!-- 🌐 Language Tabs -->
                        <div class="me-3">
                            <button class="btn btn-sm"
                                [class.btn-primary]="selectedLang === 'EN'"
                                (click)="switchLanguage('EN')">
                                English
                            </button>

                            <button class="btn btn-sm ms-2"
                                [class.btn-primary]="selectedLang === 'TE'"
                                (click)="switchLanguage('TE')">
                                Telugu
                            </button>
                        </div>

                        <!-- Filter -->
                        <div class="migration_detials1" (click)="openfilterdialog()" style="cursor: pointer;">
                            Filter
                            <span>
                                <img src="../../../../../assets/image/Filter.svg.svg"
                                     alt="filter" class="cctv_filter">
                            </span>
                        </div>

                    </div>
                </div>

                <div class="col-md-12">

                    <!-- No Data -->
                    <section class="section_one" *ngIf="rowData?.length === 0">
                        <div class="cctvcouncelling__sec">
                            <div class="councellist__flex">
                                <div>
                                    <div class="nodata_center">
                                        <figure class="mb-0">
                                            <img src="../../assets/image/nodata.png"
                                                 alt="nodata" class="nodata">
                                        </figure>
                                        <p class="no_data">No Data Found</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Table -->
                    <section *ngIf="rowData && rowData.length > 0">
                        <div class="table_data">

                            <!-- Toolbar -->
                            <div class="d-flex align-items-center mb-2">

                                <button class="btn btn-success" (click)="onBtExport()">
                                    Download Excel
                                </button>

                                <input type="text" class="form-control ms-auto"
                                    style="width: 300px"
                                    placeholder="Search..."
                                    [(ngModel)]="quickFilter"
                                    (input)="onQuickFilterChanged()" />

                            </div>

                            <!-- AG Grid -->
                            <ag-grid-angular
                                class="ag-theme-alpine"
                                style="width:100%; height: calc(100vh - 240px);"
                                [rowData]="rowData"
                                [columnDefs]="columnDefs"
                                (gridReady)="onGridReady($event)"
                                [pagination]="true"
                                [paginationPageSize]="10"
                                [paginationPageSizeSelector]="[10,20,50,100]">
                            </ag-grid-angular>

                        </div>
                    </section>

                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>